import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import NavbarLeft from "./../Components/NavbarLeft";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import Block from "./../Components/Block";
import ComTable from "./components/ComTable";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { fetchComHistory } from "../../redux/actions/comActions";
import ComponentLoading from "../../commonComponents/ComponentLoading";

const ComPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // REDUX ACTIONS
  const dispatch = useDispatch();
  const fetchComHistory_rd = () => dispatch(fetchComHistory());

  const [rand_update, set_rand_update] = useState(null);
  const [com_history_filterer, set_com_history_filterer] = useState(null);

  // REDUX STATES
  const com_history = useSelector((state) => (state.com.com_history ? state.com.com_history : null));
  const com_history_filtred = useSelector((state) =>
    state.com.com_history_filtred ? state.com.com_history_filtred : state.analysis.com_history ? state.analysis.com.com_history : null
  );

  useEffect(() => {
    async function fetch_fn() {
      setLoading(true);
      await fetchComHistory_rd();
      setLoading(false);
    }
    fetch_fn();
    // setAnalysisHistory_rd(analysis_history);
  }, []);

  return (
    <>
      <NavbarLeft currentPage={4} />
      {/* <div className="w-full h-[70px] bg-white border-r-[1px] border-[#BEC4C] fixed z-10 flex items-center justify-start ml-[25px]"> */}
      <div className="ml-[70px] h-[70px] bg-white flex items-center border-[#BEC4C]">
        <div className="ml-10 flex items-center justify-between">
          <p className="font-Poppins-SemiBold text-lg inline">Communiquer</p>
        </div>
      </div>

      <div className="w-full">
        <div className="w-full flex justify-center mt-[20px]">
          <div>
            {/* <p className="text-2xl font-Poppins-SemiBold my-[20px]">Communiquer</p> */}
            <div className=" flex justify-between w-[1150px] mt-[50px]">
              <Block navigate={navigate} currentStep={7} number={7} type={"com"} linkedto={"ReportChoice"} text="Rapport automatique" video={false} />
              <Block navigate={navigate} currentStep={8} number={8} type={"com"} linkedto={"ReportChoice"} sub_type={"kit eco-score"} text="Kit de communication\néco-score" video={false} />
              <Block navigate={navigate} currentStep={9} number={3} type={"com"} linkedto={"ReportChoice"} sub_type={"kit IME"} text="Kit de communication\nmulticritère - IME" video={false} />
            </div>
          </div>
        </div>

        <div className="w-full flex justify-center">
          <div className="mt-[50px]">
            <p className="text-2xl font-Poppins-SemiBold my-[20px] ml-[60px]">Historique de communication</p>
            {!loading && com_history && com_history_filtred ? (
              <ComTable navigate_to={"Com"} com_history={com_history_filtred} com_history_filterer={com_history_filterer} rand_update={rand_update} set_rand_update={set_rand_update} />
            ) : (
              <ComponentLoading height={35} style={"h-[400px] flex items-center justify-center"} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ComPage;
